/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessSectorExpertise
 */
export interface BusinessSectorExpertise {
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorExpertise
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorExpertise
     */
    name: string;
}

/**
 * Check if a given object implements the BusinessSectorExpertise interface.
 */
export function instanceOfBusinessSectorExpertise(value: object): value is BusinessSectorExpertise {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BusinessSectorExpertiseFromJSON(json: any): BusinessSectorExpertise {
    return BusinessSectorExpertiseFromJSONTyped(json, false);
}

export function BusinessSectorExpertiseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSectorExpertise {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function BusinessSectorExpertiseToJSON(value?: BusinessSectorExpertise | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

